import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserAreaPreference } from '../models/user-area-preference.model';

@Injectable({ providedIn: 'root' })
export class UserAreaPreferenceService {
  private http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiBaseUrl}/user-area-preference`;

  get(): Observable<UserAreaPreference | null> {
    return this.http.get<UserAreaPreference | null>(this.apiUrl);
  }

  save(preference: UserAreaPreference): Observable<UserAreaPreference> {
    return this.http.put<UserAreaPreference>(this.apiUrl, preference);
  }

  delete(): Observable<void> {
    return this.http.delete<void>(this.apiUrl);
  }
}
